var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"bmp-code-editor codemirror pa-0 ma-0",attrs:{"flat":""}},[_c('codemirror',_vm._b({ref:"cm",attrs:{"options":_vm.cmOption},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'codemirror',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }